import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createText(
  parentId: string,
  masterBlockId?: MasterBlockId,
  text?: string,
): TextInterface {
  const entity: TextInterface = {
    ...generateBaseEntity(EntityTypeEnum.Text, parentId, masterBlockId),
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    content:
      '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem dolore, alias, numquam enim ab voluptate id quam harum ducimus cupiditate similique quisquam et deserunt, recusandae.</p>',
  }

  if (text) {
    entity.content = `<p>${text}</p>`
  }

  return entity
}
